export default __webpack_public_path__ + "static/media/absolute-9.be9085d8.jpg";